import _ from 'lodash'
import { createSlice } from '@reduxjs/toolkit'

const defaultState = {
  formData: {
    id: '',
    solicitorFirmId: '',
    internalAlertText: '',
    selectedCaseType: '',
    selectedSubCaseType: '',
    validFrom: '',
    validTo: '',
  },
  solicitorCaseTypes: [],
  solicitorSubCaseTypes: [],
  fetching: false,
  posting: false,
  patching: false,
  deleting: false,
  response: '',
  badResponse: '',
}

const internalAlertFormActions = {
  resetInternalAlertFormState: (state) => {
    return defaultState
  },
  changeInternalAlertFormData: (state, { payload }) => {
    const { key, value } = payload
    if(key === 'internalAlertText' && value.length > 500) return;

    state.formData = {
      ...state.formData,
      [key]: value,
    }

    if (key === 'selectedCaseType') {
      state.formData = {
        ...state.formData,
        selectedSubCaseType: '',
      }
    } else if (key === 'solicitorFirmId') {
      state.formData = {
        ...state.formData,
        selectedCaseType: '',
        selectedSubCaseType: '',
      }
    }
  },
  changeInternalAlertFormSettings: (state, { payload }) => {
    const { key, value } = payload
    state[key] = value
  },
  createInternalAlert: (state, action) => {
    state.posting = true
  },
  createInternalAlertSuccess: (state, action) => {
    state.posting = false
    state.response = 'Internal Alert was created successfully'
    state.badResponse = ''
  },
  createInternalAlertFailed: (state, action) => {
    state.posting = false
    state.response = ''
    try {
      state.badResponse = action.payload.response.body.message
    } catch (error) {
      state.badResponse = 'Failed to create internal alert'
    }
  },
  patchInternalAlert: (state) => {
    state.patching = true
  },
  patchInternalAlertSuccess: (state) => {
    state.patching = false
    state.badResponse = ''
    state.response = 'Internal Alert was updated successfully'
  },
  patchInternalAlertFailed: (state, action) => {
    state.patching = false
    state.response = ''
    try {
      state.badResponse = action.payload.response.body.message
    } catch (error) {
      state.badResponse = 'Failed to create internal alert'
    }
  },
  getInternalAlertById: (state) => {
    state.fetching = true
  },
  receiveInternalAlertById: (state, action) => {
    state.fetching = false
    state.formData = {
      id: action.payload.body.id,
      solicitorFirmId: action.payload.body.solicitorFirmId,
      internalAlertText: action.payload.body.internalAlertText,
      selectedCaseType: action.payload.body.caseTypeId,
      selectedSubCaseType: action.payload.body.subCaseTypeId,
      validFrom: new Date(action.payload.body.validFrom),
      validTo: action.payload.body.validTo ? new Date(action.payload.body.validTo) : null,
    }
  },
  failedGetInternalAlertById: (state, action) => {
    state.fetching = false
    state.response = ''
    try {
      state.badResponse = action.payload.response.body.message
    } catch (error) {
      state.badResponse = 'Failed to get internal alert'
    }
  },
  getSolicitorGroupCaseTypes: (state) => {
    state.fetching = true
  },
  receiveSolicitorGroupCaseTypes: (state, action) => {
    const subCases = action.payload.reduce(
      (prev, item) => [...prev, ...item?.subCaseTypes],
      []
    )
    state.solicitorCaseTypes = action.payload
    state.solicitorSubCaseTypes = subCases
    state.fetching = false
  },
  failedGetSolicitorGroupCaseTypes: (state) => {
    state.fetching = false
  },
  deleteInternalAlert: (state) => {
    state.deleting = true
  },
  deleteInternalAlertSuccess: (state) => {
    state.deleting = false
    state.response = 'Internal Alert was deleted successfully'
    state.badResponse = ''
  },
  deleteInternalAlertFailed: (state, action) => {
    state.deleting = false
    state.response = ''
    try {
      state.badResponse = action.payload.response.body.message
    } catch (error) {
      state.badResponse = 'Failed to delete internal alert'
    }
  }
}
const internalAlertForm = createSlice({
  name: 'internalAlertForm',
  initialState: defaultState,
  reducers: internalAlertFormActions,
})
export const {
  resetInternalAlertFormState,
  changeInternalAlertFormData,
  changeInternalAlertFormSettings,
  createInternalAlert,
  createInternalAlertSuccess,
  createInternalAlertFailed,
  patchInternalAlert,
  patchInternalAlertSuccess,
  patchInternalAlertFailed,
  getInternalAlertById,
  receiveInternalAlertById,
  failedGetInternalAlertById,
  receiveSolicitorGroupCaseTypes,
  getSolicitorGroupCaseTypes,
  failedGetSolicitorGroupCaseTypes,
  deleteInternalAlert,
  deleteInternalAlertSuccess,
  deleteInternalAlertFailed,
} = internalAlertForm.actions
export default internalAlertForm.reducer
